import { useMemo } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import SelectSubmenu from "components/SelectSubmenu";
import MorningLayout from "../../morningLayout";
import Morning_Support from "assets/morning/support.jpg";
import { useAppContext } from "context/AppContext";

type LayoutProps = {
    children: React.ReactNode;
};

const menuItems = [
    { label: "사용문의", path: "/support/courier-inquiry" },
    { label: "공지사항", path: ["/support/notices", "/support/notices/:idx"] },
    { label: "FAQ", path: "/support/faq" },
    // { label: "일신그룹 고객센터", path: "/support/tels" },
];

const SupportLayout = ({ children }: LayoutProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;
    const { isApp } = useAppContext();
    const responsive1100 = useMediaQuery(1100);

    const activeIndex = useMemo(() => {
        // return menuItems.findIndex(item => item.path === location.pathname);

        return menuItems.findIndex(menu => {
            const paths = Array.isArray(menu.path) ? menu.path : [menu.path];
            return paths.some(pattern => matchPath(pattern, path));
        });
    }, [path]);

    return (
        <div className={`flex flex-col relative ${!isApp && "mt-[116px]"} flex-1`}>
            <MorningLayout>
                {!isApp && (
                    <div
                        className="relative bg-cover bg-top flex flex-col items-center justify-center bg-no-repeat h-60"
                        style={{ backgroundImage: `url(${Morning_Support})` }}
                    >
                        <div className="flex flex-col items-center text-white pb-[50px]">
                            <p className="text-[40px] font-bold pb-[3px]">고객센터</p>
                            <p>마음까지 전해주는 일신모닝택배</p>
                        </div>

                        <div className="flex bottom-0 absolute w-full h-[50px] bg-[rgba(21,34,65,0.85)] text-white justify-center">
                            {/* 1100 이하/이상 */}
                            {responsive1100 ? (
                                <SelectSubmenu menuItems={menuItems} activeIndex={activeIndex} />
                            ) : (
                                <>
                                    {menuItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`responsive1100:hidden w-[200px] p-2.5 flex items-center justify-center border-l border-gray-600 text-[17px] cursor-pointer ${
                                                activeIndex === index
                                                    ? "bg-[#f4f4f4] text-[#0e0057] relative after:absolute after:bottom-[-1px] after:left-0 after:w-full after:h-[1px] after:bg-[#f4f4f4]"
                                                    : "text-white"
                                            } ${index === menuItems.length - 1 ? "border-r" : ""}`}
                                            onClick={() => {
                                                const path = item.path instanceof Array ? item.path[0] : item.path;
                                                navigate(path);
                                            }}
                                        >
                                            {item.label}
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                )}

                {children}
            </MorningLayout>
        </div>
    );
};

export default SupportLayout;
